import {
  Box,
  Button,
  Center,
  HStack,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  PinInput,
  PinInputField,
  Text,
} from '@chakra-ui/react'
import { useDeviceType } from 'app/hooks'
import CustomButton from 'Components/CustomButton'
import React from 'react'
interface IOtpVerificationModal {
  showGoBackToRegistration?: boolean
  onClose: () => void
  isOpen: boolean
  loginPhoneNumber: string
  maskedPhone?: string
  maskedEmail?: string
  otpInput: string
  setOtpInput: React.Dispatch<React.SetStateAction<string>>
  isLoading: boolean
  verifyClickHandler: () => Promise<void>
  handleResendOTP: () => Promise<void>
}
const OtpVerificationModal = ({
  handleResendOTP,
  onClose,
  isOpen,
  loginPhoneNumber,
  maskedPhone,
  maskedEmail,
  otpInput,
  setOtpInput,
  isLoading,
  verifyClickHandler,
  showGoBackToRegistration = true,
}: IOtpVerificationModal) => {
  const { isMobile } = useDeviceType()
  return (
    <Modal
      onClose={() => {
        onClose()
        setOtpInput('')
      }}
      size={isMobile ? 'xs' : '2xl'}
      isOpen={isOpen}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader textAlign='center' pt='16'>
          OTP Verification
        </ModalHeader>
        <ModalCloseButton p='10' />
        <ModalBody textAlign='center'>
          <Box>
            <Text fontSize='sm' fontWeight='medium'>
              {maskedPhone && maskedEmail
                ? `Please enter the OTP sent to mobile ${maskedPhone} and email ${maskedEmail}.`
                : maskedPhone
                ? `Please enter the OTP sent to mobile ${maskedPhone}.`
                : maskedEmail
                ? `Please enter the OTP sent to email ${maskedEmail}.`
                : loginPhoneNumber
                ? `Please enter the One-Time Password sent to mobile number +91-XXXXX-X${loginPhoneNumber.slice(
                    -4,
                  )}`
                : 'Please enter the OTP sent to your registered mobile and email.'}
            </Text>
          </Box>
          <Center>
            <HStack mt='5'>
              <PinInput
                variant='outline'
                type='number'
                value={otpInput}
                onChange={(e) => {
                  setOtpInput(e)
                }}
              >
                <PinInputField />
                <PinInputField />
                <PinInputField />
                <PinInputField />
                <PinInputField />
                <PinInputField />
              </PinInput>
            </HStack>
          </Center>
          <Box>
            <CustomButton
              disabled={otpInput.length !== 6}
              buttonText='Verify'
              isLoading={isLoading}
              buttonColor='#93C025'
              my='30px'
              handlerFunction={verifyClickHandler}
            />
          </Box>
          <Box>
            <Text fontSize='xs' fontWeight='medium'>
              Didn’t receive OTP?{' '}
              <Button
                onClick={() => handleResendOTP()}
                fontSize={'xs'}
                color='#0D7DD0'
                fontWeight='semibold'
                variant={'link'}
              >
                Resend OTP
              </Button>
            </Text>
          </Box>
          {showGoBackToRegistration && (
            <Box py='3'>
              <Text fontSize='xs' fontWeight='medium'>
                Entered wrong number?{' '}
                <Button
                  fontSize={'xs'}
                  variant={'link'}
                  color='#0D7DD0'
                  fontWeight='semibold'
                  onClick={() => onClose()}
                >
                  Go back to registration
                </Button>
              </Text>
            </Box>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
export default OtpVerificationModal
